import React, { useState, useMemo } from 'react'
import QR from 'qrcode.react'
import saveAs from 'file-saver'
import { useFormState } from 'informed'
import { useTranslation } from 'react-i18next'

import Button from 'components/Button'
import { Select } from 'components/forms'
import { useQuery } from 'components/graphql'
import listRestaurant from '../../../gql/listRestaurant'
import Divider from 'components/Divider'

const QRCode = ({ companyId, cashRegisterId }) => {
	const [table, setTable] = useState()
	const formState = useFormState()
	const designProjectId = formState?.values?.parameters?.designProject
	const [t] = useTranslation()

	const { data: restaurantData } = useQuery(listRestaurant, {
		variables: { projectId: designProjectId }
	})
	const tables = useMemo(() => {
		if(!designProjectId) {
			return []
		}
		return restaurantData?.listRestaurant?.items?.filter?.(item => {
			if(!item?.caption) {
				item.caption = t('options_section.strings.unnamed_table')
			}
			return item.objectKind === 1 && item.objectType === 'object'
		})
	}, [restaurantData, designProjectId])

	const handleSave = () => {
		const canvas = document.getElementById('qrCodeCanvas')
		canvas.toBlob(blob => {
			saveAs(blob, `QR-Code_${t('common.strings.table')}-${table?.caption}.png`)
		})
	}

	return(
		<>
			<Select
				noForm
				onChange={val => setTable(val)}
				options={tables}
				label={t('common.strings.table')}
				labelField='caption'
				valueField='id'
				disabled={!designProjectId}
				{...!designProjectId && { error: t('options_section.strings.select_location') }}
			/>
			{(designProjectId && table) &&
			<>
				<QR
					value={`https://qrmenu.d2090b7o5agton.amplifyapp.com/qr-menu?table=${table?.id}&guid=${companyId}&register=${cashRegisterId}`}
					id='qrCodeCanvas'
				/>
				<Divider />
				<Button
					text={t('common.buttons.download')}
					onClick={handleSave}
					type='button'
				/>
			</>
			}
		</>
	)
}

export default QRCode
